import { useDispatch, useSelector } from "react-redux";
import AdvertLarge from "../../components/advertLarge/AdvertLarge";
import AdvertTop from "../../components/advertTop/AdvertTop";
import AudioVideo from "../../components/audioVideo/AudioVideo";
import FoodRecipe from "../../components/foodRecipe/FoodRecipe";
import FooterLinks from "../../components/footer/FooterLinks";
import { Hotlinks } from "../../components/hotlinks/Hotlinks";
import { MainBody } from "../../components/mainBody/MainBody";
import MainBodyFour from "../../components/mainBodyFour/MainBodyFour";
import MainBodyThree from "../../components/mainBodyThree/MainBodyThree";
import MainBodyTwo from "../../components/mainBodyTwo/MainBodyTwo";
import MainContent from "../../components/mainContent/MainContent";
import NavbarBottom from "../../components/navbarBottom/NavbarBottom";
import NavbarBottomMobile from "../../components/navbarBottomMobile/NavbarBottomMobile";
import PhotoGal from "../../components/photoGal/PhotoGal";
import "./Home.scss";
import { getPosts } from "../../redux/features/post/postSlice";
import { useEffect, useState } from "react";

import { FaArrowAltCircleUp } from "react-icons/fa";
import CarouselItem from "../../components/carousel/CarouselItem";
import PostCarousel from "../../components/carousel/Carousel";
import axios from "axios";
import MostRead from "../../components/mostRead/MostRead";
import Icymi from "../../components/icymiPosts/Icymi";
const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  const { posts } = useSelector((state) => state.post);
  // const technology = posts.find((post) => post?.category === "Technology");

  const latest = posts
    ?.filter((post) => {
      return post;
    })
    ?.filter((post, index) => index < 7);

  const latestPost = latest?.map((item) => {
    return (
      <div key={item?._id}>
        <CarouselItem
          category={item?.category}
          url={item?.image[0]}
          title={item?.title}
          post={item}
        />
      </div>
    );
  });

  const job = posts
    ?.filter((post) => {
      return post;
    })
    ?.filter((post) => {
      return post?.category === "Jobs";
    })

    ?.filter((post, index) => index < 7);

  const latestJob = job?.map((item) => {
    return (
      <div key={item?._id}>
        <CarouselItem
          category={item?.category}
          url={item?.image[0]}
          title={item?.title}
          post={item}
        />
      </div>
    );
  });

  return (
    <div className="home">
      <div className="homeWrapper">
        <AdvertTop />
        <NavbarBottom />
        <NavbarBottomMobile />
        <Hotlinks />
        <MainContent />
        <AudioVideo />
        <PostCarousel posts={latestPost} />
        <MainBody />
        <MainBodyTwo />
        <MainBodyThree />
        <AdvertLarge />
        <PostCarousel posts={latestJob} />
        <MainBodyFour />
        <Icymi />
        <FoodRecipe />
        {/* <PhotoGal /> */}
        <FooterLinks />
      </div>
    </div>
  );
};
export default Home;
